export const normalizeApiBaseUrl = (value = "") => {
  const trimmed = String(value || "").trim();

  if (!trimmed) {
    return "";
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed.replace(/\/+$/, "").replace(/\/api$/i, "");
  }

  const normalizedPath = `/${trimmed.replace(/^\/+/, "").replace(/\/+$/, "")}`;
  return normalizedPath === "/api" ? "" : normalizedPath.replace(/\/api$/i, "");
};

export const getConfiguredApiBaseUrl = () => normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL || "");

export const buildApiUrl = (path: string, base = getConfiguredApiBaseUrl()) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizeApiBaseUrl(base)}${normalizedPath}`;
};

export const getApiBaseCandidates = (preferredBase = "") => {
  const bases = new Set<string>();
  const configuredBase = getConfiguredApiBaseUrl();

  if (configuredBase) {
    bases.add(configuredBase);
  }

  if (preferredBase) {
    bases.add(normalizeApiBaseUrl(preferredBase));
  }

  // Same-origin fallback for local dev and reverse-proxy deployments.
  bases.add("");

  if (typeof window !== "undefined" && window.location?.origin) {
    bases.add(normalizeApiBaseUrl(window.location.origin));

    const isLocalHost = /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname || "");
    if (isLocalHost && import.meta.env.DEV) {
      // Common backend dev ports when frontend runs on a separate Vite port.
      bases.add("http://localhost:5001");
      bases.add("http://127.0.0.1:5001");
      bases.add("http://localhost:5000");
      bases.add("http://127.0.0.1:5000");
    }
  }

  let result = Array.from(bases);
  const isProdEnv = Boolean(
    import.meta.env.PROD ||
    (typeof window !== "undefined" &&
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1" &&
      !window.location.hostname.startsWith("192.168."))
  );

  if (isProdEnv) {
    result = result.filter((base) => {
      const lower = base.toLowerCase();
      return !lower.includes("localhost") && !lower.includes("127.0.0.1");
    });
    if (!result.includes("")) {
      result.push("");
    }
  }

  return result;
};
